<section [formGroup]="form">
    <p class="text-primary-900 text-base !font-medium">
        Provide a location description to begin schedule D.
    </p>
    <app-application-form-field
        label="Location Description"
        [tooltipMessage]="messages.locationDescriptionTooltip"
        [dialogTooltip]="true"
        dialogTooltipTitle="Location Description"
        [inline]="true"
        [showTooltipIcon]="true"
    >
        <mat-form-field appearance="outline" class="w-full max-w-[400px]">
            <mat-label>Location Description</mat-label>
            <mat-select formControlName="locationTypeCode" #locationTypeField>
                @for (option of getLocationTypes(); track option.value) {
                    <mat-option [value]="option.value">{{
                        option.label
                    }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
    </app-application-form-field>
    @if (showFixedControls()) {
        <app-application-form-field
            label="Location Name"
            [tooltipMessage]="messages.locationNameTooltip"
            [inline]="true"
            [showTooltipIcon]="true"
        >
            <mat-form-field
                appearance="outline"
                class="w-full max-w-[400px]"
                color="primary"
            >
                <mat-label>Location Name</mat-label>
                <input
                    title="Location Name"
                    matInput
                    maxlength="20"
                    [appRegexInput]="
                        regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                    "
                    formControlName="locationName"
                />
            </mat-form-field>
        </app-application-form-field>

        <div
            class="flex flex-col space-y-2 md:flex-row md:space-x-3 md:space-y-0 mb-5"
        >
            <a
                mat-button
                mat-raised-button
                color="primary"
                [href]="externalLinks.asrTowairSearch"
                target="_blank"
                rel="noopener"
                >Search TOWAIR</a
            >
            <a
                mat-button
                mat-raised-button
                color="primary"
                [href]="externalLinks.asrRegistrationSearch"
                target="_blank"
                rel="noopener"
                >Search ASR</a
            >
        </div>

        <app-application-form-field
            label="Location Name"
            [tooltipMessage]="messages.towerRegistrationNumberTooltip"
            [inline]="true"
            [dialogTooltip]="true"
            dialogTooltipTitle="FCC ASR Number"
            [showTooltipIcon]="true"
        >
            <mat-form-field
                appearance="outline"
                class="w-full max-w-[400px]"
                color="primary"
            >
                <mat-label>FCC ASR Number</mat-label>
                <input
                    title="FCC ASR Number"
                    matInput
                    [errorStateMatcher]="dirtyErrorStateMatcher"
                    maxlength="8"
                    [pattern]="
                        scheduleDStepOneRegExPattern.TowerRegistrationNumber
                    "
                    [appRegexInput]="
                        scheduleDStepOneRegExPattern.TowerRegistrationNumberAllowedCharacters
                    "
                    formControlName="towerRegistrationNumber"
                />
            </mat-form-field>
        </app-application-form-field>

        <app-application-form-field
            label="Help Registering This Site With the FCC or FAA?"
            [tooltipMessage]="messages.requireEWAToRegisterTowerTooltip"
            [inline]="true"
            [showTooltipIcon]="true"
        >
            <mat-form-field
                appearance="outline"
                class="w-full max-w-[400px]"
                color="primary"
            >
                <mat-label
                    >Help Registering This Site With the FCC or FAA?</mat-label
                >
                <mat-select formControlName="requireEWAToRegisterTower">
                    @for (
                        yesNoOption of yesNoOptions;
                        track yesNoOption.value
                    ) {
                        <mat-option [value]="yesNoOption.value">{{
                            yesNoOption.label
                        }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </app-application-form-field>
    }
    @if (showNonFixedControls()) {
        <app-application-form-field
            label="Area of Operation Code"
            [inline]="true"
            [tooltipMessage]="messages.areaOfOperationCodeTooltip"
            dialogWidth="800px"
            [dialogTooltip]="true"
            dialogTooltipTitle="Area of Operation Code"
            [showTooltipIcon]="true"
        >
            <mat-form-field appearance="outline" class="w-full max-w-[400px]">
                <mat-label>Area of Operation Code</mat-label>
                <mat-select formControlName="areaOfOperationCode">
                    @for (
                        option of filteredAreaOfOperationCodes;
                        track option.value
                    ) {
                        <mat-option [value]="option.value">{{
                            option.label
                        }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </app-application-form-field>
    }
</section>
